import React from "react";
import { Nav } from "react-bootstrap";
import classNames from "classnames";
import PropTypes from "prop-types";

import "./styles.scss";

const NavItem = ({ children, index, className = "" }) => (
  <Nav.Item key={index} className={classNames("mydpd-tab-nav-item", className)}>
    <Nav.Link eventKey={index} key={index}>
      {children}
    </Nav.Link>
  </Nav.Item>
);
NavItem.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  index: PropTypes.number.isRequired,
};

export default NavItem;
